<template>
  <div>
    <H5Info v-if="isMobile || isMGAppInPad" />
    <Info v-else />
  </div>
</template>

<script>
import { isH5, isMGAppInPad, isMobile } from "@saas/components/src";
import H5Info from "./H5Info";
import Info from "./Info.vue";
export default {
  components: { H5Info, Info },
  data: function () {
    return {
      isMobile: false,
      isMGAppInPad: false,
    };
  },
  created() {
    this.isMGAppInPad = isMGAppInPad();
    this.isMobile = isMobile();
  },
};
</script>

<style></style>
